import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router';

const PrivateRoute = ({ user, component: Component, render, ...other }) => (
  <Route
    {...other}
    render={props =>
      user ? (
        Component ? (
          <Component {...props} />
        ) : (
          render(props)
        )
      ) : (
        <Redirect
          to={{
            pathname: '/login',
            state: { referrer: props.location.pathname },
          }}
        />
      )
    }
  />
);

const mapStateToProps = ({ oidc: { user } }) => ({
  user,
});

export default connect(mapStateToProps)(PrivateRoute);
